import { canActor } from '../domain/authorization'
import type { ActorContext } from '../domain/authorization'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { WorkItem, WorkItemPort, WorkItemWorkState } from '../domain/workflow'

const setWorkState = async (
	port: WorkItemPort,
	item: WorkItem,
	ctx: ActorContext,
	workState: WorkItemWorkState,
	notify: NotifyPort,
	phaseTeamId: string | null = null,
): Promise<WorkItem | null> => {
	if (!canActor('set_work_state', item, ctx, phaseTeamId)) {
		notify.error('workItem.denyAdvance')
		return null
	}
	try {
		return await port.setWorkState(item.id, workState, ctx.actorId, ctx.actorName)
	} catch {
		notify.error('workItem.advanceFailed')
		return null
	}
}

export { setWorkState }
